import { connect } from 'react-redux';
import MagicLinkRequest from 'components/AuthNew/MagicLinkRequest';
import Actions from 'store/auth/actions';

const mapStateToProps = state => {
  return {
    isMagicLinkRequesting: state.auth.isMagicLinkRequesting,
    magicLinkData: state.auth.magicLinkData,
    error: state.auth.error,
    requestType: state.auth.requestType,
  };
};

const mapDispatchToProps = {
  requestMagicLink: Actions.Creators.createMagicLinkRequest,
  clearMagicLinkData: Actions.Creators.clearMagicLinkData,
};

export default connect(mapStateToProps, mapDispatchToProps)(MagicLinkRequest);
